import React from 'react'
import { Col, Container, Row } from 'react-bootstrap'
import ContentBlock from '../../components/common/component-card/ContentBlock'
import Flex from '../../components/common/Flex'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { useAppSelector } from '../../store/store'
import DashboardList from '../dashboard/DashboardList'
import AlarmCard from './components/AlarmCard'
import { AlarmSeverity } from '../../shared/models/alarm.model'

const DefaultHomeCustomerDashboard = () => {
  const currentUser = useAppSelector((state) => state.currentUser)
  return (
    <Container fluid>
      <Row className={'mt-2'}>
        <Col sm={12} md={6} lg={4} className={'px-1 h-100'}>
          <ContentBlock>
            <ContentBlock.Header className={'border-bottom py-1'}>
              <Flex>
                <FontAwesomeIcon
                  icon={'triangle-exclamation'}
                  className={'me-1 mt-1 text-primary'}
                />
                <h5 className={'text-primary mb-0'}>Alertes</h5>
              </Flex>
            </ContentBlock.Header>
            <ContentBlock.Body noLight className={'pt-1'}>
              <Row>
                <Col className={'p-1'}>
                  <AlarmCard
                    title={'Assignées'}
                    className={'shadow-none bg-warning-subtle'}
                    tenantID={currentUser.tenantID}
                    customerID={
                      currentUser.customerID
                        ? currentUser.customerID
                        : undefined
                    }
                  />
                </Col>
                <Col className={'p-1'}>
                  <AlarmCard
                    title={'Critiques'}
                    className={'shadow-none bg-danger-subtle'}
                    tenantID={currentUser.tenantID}
                    customerID={
                      currentUser.customerID
                        ? currentUser.customerID
                        : undefined
                    }
                    severity={AlarmSeverity.CRITICAL}
                  />
                </Col>
                <Col className={'p-1'}>
                  <AlarmCard
                    title={'Total'}
                    className={'shadow-none bg-info-subtle'}
                    tenantID={currentUser.tenantID}
                    customerID={
                      currentUser.customerID
                        ? currentUser.customerID
                        : undefined
                    }
                  />
                </Col>
              </Row>
            </ContentBlock.Body>
          </ContentBlock>
        </Col>
      </Row>
      <Row>
        <Col md={12}>
          <DashboardList linkTo={'dashboards/all/'} />
        </Col>
      </Row>
    </Container>
  )
}

export default DefaultHomeCustomerDashboard
